export let FormType;

(function (FormType) {
  FormType["SignupInterest"] = "SIGNUP_INTEREST";
  FormType["SignupCompleted"] = "SIGNUP_COMPLETED";
})(FormType || (FormType = {}));